import { KitsDesktop } from '../../../../components/kits/kits.desktop';
import kitsFeatureMobile from './kits';

export default kitsFeatureMobile(KitsDesktop);
